export default {"src":"/_next/static/media/BrownDeleteButton.c77d2330.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};